import { useState } from "react";
import {
  api_private_post,
  formatStringAmountCredits,
  showAlert,
} from "script";

function formatLimit(user) {
  return user.effective_prediction_limit === null
    ? "Unlimited"
    : formatStringAmountCredits(
        user.effective_prediction_limit,
        user.account_type,
      );
}

export default function AdminLimitsTab() {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [target, setTarget] = useState(null);
  const [useDefault, setUseDefault] = useState(true);
  const [limit, setLimit] = useState("");
  const [busy, setBusy] = useState(false);

  const searchUsers = (event) => {
    event.preventDefault();
    if (query.trim().length < 2) {
      showAlert("Enter at least two characters of a name or email.", "danger");
      return;
    }
    setBusy(true);
    api_private_post(
      "/admin/account/search",
      { query: query.trim() },
      (data) => {
        setBusy(false);
        setResults(data?.users || []);
      },
      () => {
        setBusy(false);
        showAlert("Unable to search users.", "danger");
      },
    );
  };

  const selectUser = (user) => {
    setTarget(user);
    setResults([]);
    setQuery(`${user.display_name} (${user.email})`);
    const hasOverride = user.prediction_limit !== null;
    setUseDefault(!hasOverride);
    setLimit(hasOverride ? Number(user.prediction_limit).toFixed(2) : "");
  };

  const saveLimit = (event) => {
    event.preventDefault();
    if (!target || busy) return;
    const numericLimit = Number(limit);
    if (!useDefault && (!Number.isFinite(numericLimit) || numericLimit <= 0)) {
      showAlert("Enter a prediction limit above zero.", "danger");
      return;
    }
    setBusy(true);
    api_private_post(
      "/admin/account/set-prediction-limit",
      {
        user_id: target.user_id,
        use_default: useDefault,
        prediction_limit: numericLimit,
      },
      (data) => {
        setBusy(false);
        if (!data?.success) {
          showAlert(data?.error || "Unable to save the limit.", "danger");
          return;
        }
        setTarget(data.user);
        showAlert("Prediction limit saved.", "success");
      },
      () => {
        setBusy(false);
        showAlert("Unable to save the limit.", "danger");
      },
    );
  };

  return (
    <div className="pay_method__paymethod p-4 p-lg-6 p2-bg rounded-8">
      <div className="pay_method__paymethod-title mb-5">
        <h5 className="n10-color">Prediction limits</h5>
      </div>

      <form className="mb-5" onSubmit={searchUsers}>
        <label className="mb-2" htmlFor="admin-limit-user-search">
          Find user by name or email
        </label>
        <div className="d-flex gap-3 align-items-stretch">
          <input
            id="admin-limit-user-search"
            className="n11-bg rounded-8 w-100"
            value={query}
            onChange={(event) => {
              setQuery(event.target.value);
              setResults([]);
              setTarget(null);
            }}
          />
          <button className="cmn-btn px-5 py-3" type="submit" disabled={busy}>
            Search
          </button>
        </div>
      </form>

      {results.length > 0 && (
        <div className="admin-user-search-results n11-bg rounded-8 mb-6">
          {results.map((user) => (
            <button
              key={user.user_id}
              type="button"
              className="admin-user-search-result w-100 p-4 text-start"
              onClick={() => selectUser(user)}
            >
              <strong>{user.display_name}</strong>
              <span>{user.email}</span>
              <small>
                {user.account_type === "real" ? "Real currency" : "Credits"}
                {" · Current limit "}
                {formatLimit(user)}
              </small>
            </button>
          ))}
        </div>
      )}

      {target && (
        <form onSubmit={saveLimit}>
          <div className="n11-bg rounded-8 p-4 mb-5">
            <strong>{target.display_name}</strong>
            <div>{target.email}</div>
            <small>Effective limit: {formatLimit(target)}</small>
          </div>

          <div className="d-flex gap-4 flex-wrap mb-4">
            <label className="d-flex align-items-center gap-2">
              <input
                type="radio"
                checked={useDefault}
                onChange={() => setUseDefault(true)}
              />
              Account default (
              {target.account_type === "real" ? "$15.00" : "Unlimited"})
            </label>
            <label className="d-flex align-items-center gap-2">
              <input
                type="radio"
                checked={!useDefault}
                onChange={() => setUseDefault(false)}
              />
              Custom limit
            </label>
          </div>

          {!useDefault && (
            <div className="mb-5">
              <label className="mb-2" htmlFor="admin-prediction-limit">
                Maximum stake per prediction
              </label>
              <input
                id="admin-prediction-limit"
                className="n11-bg rounded-8 w-100"
                type="number"
                min="0.01"
                step="0.01"
                value={limit}
                onChange={(event) => setLimit(event.target.value)}
                required
              />
            </div>
          )}

          <button className="cmn-btn px-5 py-3" type="submit" disabled={busy}>
            {busy ? "Saving..." : "Save limit"}
          </button>
        </form>
      )}
    </div>
  );
}
